export const MODULE_ABBR = {
  PURCHASE_ORDER: 'PO',
  PURCHASE_REQUEST: 'PR',
};

// Dạng chữ thường, dùng sau các động từ (Danh sách / Sửa / Tạo / Thông tin / Import ...).
export const MODULE_LABELS_LOWER = {
  PURCHASE_ORDER: `phiếu yêu cầu nhập hàng (${MODULE_ABBR.PURCHASE_ORDER})`,
  PURCHASE_REQUEST: `phiếu đề nghị mua hàng (${MODULE_ABBR.PURCHASE_REQUEST})`,
};

const capFirst = (s) => s.charAt(0).toUpperCase() + s.slice(1);

// Dạng đứng đầu nhãn (sidebar, breadcrumb cấp trên).
export const MODULE_LABELS = {
  PURCHASE_ORDER: capFirst(MODULE_LABELS_LOWER.PURCHASE_ORDER),
  PURCHASE_REQUEST: capFirst(MODULE_LABELS_LOWER.PURCHASE_REQUEST),
};
